import { BookOptionOption } from "@app/types";
import { RoutePath } from "./common.const";

export const BannerAdsPosition = {
  HOME_SCREEN: "home_screen",
  BOOK_DETAIL_SCREEN: "book_detail_screen",
  VAS_CHARGING_SCREEN: "vas_charging_screen",
  BOOK_FREE_SCREEN: "book_free_screen",
};

export type BannerAdsPosition =
  (typeof BannerAdsPosition)[keyof typeof BannerAdsPosition];

export const BannerAdsNavigateTo = {
  BOOK_FREE_SCREEN: "book_free_screen",
} as const;

export type BannerAdsNavigateTo =
  (typeof BannerAdsNavigateTo)[keyof typeof BannerAdsNavigateTo];

export const BannerAdsNavigateToRoutePath = {
  [BannerAdsNavigateTo.BOOK_FREE_SCREEN]: `${RoutePath.BOOK_BY_OPTION}?option=${BookOptionOption.FREE}`,
} as const;
